export const DEFAULT_GRID_BACKGROUND = {
  fill: '#bbb',
  fillOpacity: 0.2
};
